import { AfterResponseMiddleware } from '../types';

/**
 * Parse the response's `body` depending on the `content-type` header.
 */
export const responseBody: AfterResponseMiddleware = async res => {
  try {
    const mimeType = res.headers.get('content-type') || '';
    if (mimeType.startsWith('application/json')) {
      /* eslint-disable-next-line require-atomic-updates */
      res.body = await res.response.json();
    } else if (mimeType.startsWith('text/')) {
      /* eslint-disable-next-line require-atomic-updates */
      res.body = await res.response.text();
    }
  } catch (err) {
    // Silent error
  }
  return res;
};
